export const AVATAR_SIGNATURE = 'AVATAR_SIGNATURE'

export const AVATAR_CONFIG = 'AVATAR_CONFIG'
export const AVATAR_CONFIG_SUCCESS = 'AVATAR_CONFIG_SUCCESS'
export const AVATAR_CONFIG_FAILURE = 'AVATAR_CONFIG_FAILURE'



